module.exports = __webpack_public_path__ + "img/六分相.2e408af3.svg";